import { ElementFormatType, ElementNode, LexicalNode, NodeKey, SerializedLexicalNode, Spread } from "lexical";

export interface ImagePayload {
	src: string;
	altText: string;
	width?: number | string;
	height?: number | string;
	key?: NodeKey;
}

export type SerializedImageNode = Spread<
	{
		type: "image";
		version: number;
		format: ElementFormatType;
		indent: number;
		direction: "ltr" | "rtl" | null;
		src: string;
		altText: string;
		width?: number | string;
		height?: number | string;
		children: SerializedLexicalNode[];
	},
	SerializedLexicalNode
>;

export class ImageNode extends ElementNode {
	__src: string;
	__altText: string;
	__width?: number | string;
	__height?: number | string;

	static getType(): string {
		return "image";
	}

	static clone(node: ImageNode): ImageNode {
		return new ImageNode(node.__src, node.__altText, node.__width, node.__height, node.__key);
	}

	constructor(src: string, altText: string, width?: number | string, height?: number | string, key?: NodeKey) {
		super(key);
		this.__src = src;
		this.__altText = altText;
		this.__width = width;
		this.__height = height;
	}

	exportJSON(): SerializedImageNode {
		return {
			type: "image",
			version: 1,
			format: "",
			indent: 0,
			direction: null,
			src: this.__src,
			altText: this.__altText,
			width: this.__width,
			height: this.__height,
			children: [],
		};
	}

	static importJSON(json: SerializedImageNode): ImageNode {
		const node = $createImageNode({
			src: json.src,
			altText: json.altText,
			width: json.width,
			height: json.height,
		});
		return node;
	}

	createDOM(): HTMLElement {
		const div = document.createElement("div");
		div.style.display = "flex";
		div.style.justifyContent = "center";
		div.style.margin = "10px 0";

		const img = document.createElement("img");
		img.src = this.__src;
		img.alt = this.__altText;
		img.style.maxWidth = "100%";
		img.style.height = "auto";

		if (this.__width && this.__width !== "auto") {
			img.style.width = typeof this.__width === "number" ? `${this.__width}px` : this.__width;
		}
		if (this.__height && this.__height !== "auto") {
			img.style.height = typeof this.__height === "number" ? `${this.__height}px` : this.__height;
		}

		div.appendChild(img);
		return div;
	}

	updateDOM(): false {
		return false;
	}

	isInline(): boolean {
		return false;
	}
}

export function $createImageNode(payload: ImagePayload): ImageNode {
	const { src, altText, width, height, key } = payload;
	return new ImageNode(src, altText, width, height, key);
}

export function $isImageNode(node: LexicalNode): node is ImageNode {
	return node instanceof ImageNode;
}
